const PRODUCTION_API_HOST = 'api.tattersallgda.cl';
const LOCAL_API_URL = 'http://localhost:5000';

export const getApiBaseUrl = () => {
  const configuredUrl = process.env.REACT_APP_BACKEND_ALB || LOCAL_API_URL;

  if (process.env.NODE_ENV === 'development' && configuredUrl.includes(PRODUCTION_API_HOST)) {
    console.warn(
      `REACT_APP_BACKEND_ALB points to production in local development. Using ${LOCAL_API_URL}.`
    );
    return LOCAL_API_URL;
  }

  return configuredUrl;
};

export default getApiBaseUrl;
